import axios from "axios"

export const fetchMultiCallerStateAPI = () => axios
  .get(`${process.env.REACT_APP_API_BASE_URL}/v1.0/gabby/caller/multicaller`)

export const changeMultiCallerStateAPI = payload => axios
  .put(`${process.env.REACT_APP_API_BASE_URL}/v1.0/gabby/caller/multicaller`, payload)
